import MapViewer from "@/components/map/map-viewer";
import React from "react";

export default function MapTab() {
  return <MapViewer />;
}
